'use strict';

bbw.directive.bbwMore = ['safeApply', 'bbw.TruncateSvc', '$compile', 'bbw.LayoutTypeSvc', '$window', function(safeApply, truncateSvc, $compile, layoutTypeSvc, $window) {

    var DEFAULT_LEN = 300;

    var bindMsgTpl = '<span bbw-bind-msg="value"></span>';
    var expandHtml = '<a href ng-hide="isExpanded()" ng-click="expand($event)" ng-class="moreClass" ng-bind="moreText"></a>';
    var noExpandHtml = '<span class="pseudo-link" ng-bind="moreText"></span>';

    return {
        restrict: 'A',
        scope: {
            'bbwMore': '=',
            'bbwMoreHtml': '=',
            'bbwMoreNoExpand': '=',
            'rawHtml': '='
        },
        link: function(scope, element, attr) {
            scope.isExpanded = function() {
                return scope.expanded || !scope.moreText;
            };

            var buildRawHtml = function(html) {
                if (scope.isExpanded()) {
                    element.html(html);
                } else {
                    var innerElement = angular.element(html);
                    var lastChild = innerElement[innerElement.length - 1];
                    var appendNode;
                    switch (lastChild.nodeName) {
                        case 'DIV':
                        case 'P':
                            appendNode = lastChild;
                            break;
                        default:
                            appendNode = innerElement;
                    }
                    appendNode.innerHTML += ' ' + (scope.bbwMoreNoExpand ? noExpandHtml : expandHtml);
                    element.empty();
                    angular.forEach(innerElement, function(el) {
                        element.append(el);
                    });
                }
            };

            var buildMsgHtml = function(msg) {
                scope.value = ngtk.tools.string.unescapeHtml(msg);
                element.html(bindMsgTpl + expandHtml);
            };

            var compile = function(html) {
                if (scope.rawHtml) {
                    buildRawHtml(html);
                } else {
                    buildMsgHtml(html);
                }
                $compile(element.contents())(scope);
            };

            var lastLayout;
            var update = function() {
                var length;
                if (angular.isObject(scope.bbwMore)) {
                    lastLayout = layoutTypeSvc.getLayoutType();
                    length = scope.bbwMore[lastLayout];
                } else {
                    length = scope.bbwMore;
                }
                length = parseInt(length);
                if (!(length > 0)) {
                    length = DEFAULT_LEN;
                }
                var origHtml = scope.bbwMoreHtml;

                var truncatedHtml = truncateSvc.truncate(origHtml, length);

                if (origHtml === truncatedHtml) {
                    scope.expanded = true;
                    return compile(origHtml);
                }

                scope.expand = function($event) {
                    scope.expanded = true;
                    compile(origHtml);
                    $event.preventDefault();
                    return false;
                };

                scope.expanded = false;
                scope.moreText = attr.bbwMoreText || 'Показать полностью';
                if (scope.moreText === 'false') {
                    scope.moreText = '';
                }
                scope.moreClass = attr.bbwMoreClass || 'bbw-more-expand';

                compile(truncatedHtml);
            };

            scope.$watch('bbwMore', function(newValue, oldValue) {
                //noinspection JSValidateTypes
                if (newValue != oldValue) {
                    update();
                }
            });
            scope.$watch('bbwMoreHtml', function(newValue, oldValue) {
                //noinspection JSValidateTypes
                if (newValue !== oldValue) {
                    update();
                }
            });

            function updateOnResize() {
                if (lastLayout != layoutTypeSvc.getLayoutType()) {
                    update();
                }
            }

            if (angular.isObject(scope.bbwMore)) {
                $window.addEventListener('resize', updateOnResize);
                scope.$on('$destroy', function() {
                    $window.removeEventListener('resize', updateOnResize);
                });
            }

            update();
        }
    };
}];
